

module.exports = angular.module('msi.subscriptions.pause', [
  'ui.router',
  require('@ordergroove/brandy/src/app/modals/confirmation-dialog'),
  require('@ordergroove/brandy/src/app/toasts')
]).name;

angular.module(module.exports)
  .controller('PauseSubscriptionController', require('./pause.controller'))
  .component('ogPauseSubscriptionButton', require('./pause-button'))
  .config(require('./state'));
